<template>
  <fgt-icons :name="name" :title="title"></fgt-icons>
</template>

<script>
import fgtIcons from "../icons/fgt-icons.vue";
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    set: {
      type: String
    }
  },
  components: {
    fgtIcons
  },
  computed: {
    iconSet() {
      return this.set ? this.set : this.defaultSet;
    }
  }
};
</script>
